import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "./utils/axios";
import Swal from "sweetalert2";
import Moment from "moment";
import "@/assets/tailwind.css";

const app = createApp(App);
app.use(store);
app.use(router);
app.provide("$axios", axios);
app.provide("$router", router);
app.provide("$store", store);
app.provide("$swal", Swal);
app.provide("$moment", Moment);
app.mount("#app");